import { ApiStatus } from '../components/api-status';

export default function ApiStatusPage() {
  return (
    <div className="container mx-auto p-4">
      <h1 className="text-2xl font-bold mb-6">API Connection Status</h1>
      <p className="mb-6">
        This page tests the connections to various API endpoints using the simplified backend.
      </p>
      
      <ApiStatus />
    </div>
  );
}